import { IntegrityMonitorAssignRulesFormBaseDataProvider } from './IntegrityMonitorAssignRulesFormBaseDataProvider';
import { RuleSetOption } from '../types';
import { sanitizeObject } from '../../../../utils/sanitization.utils';

export class IntegrityMonitorAssignRulesFormGzDataProvider extends IntegrityMonitorAssignRulesFormBaseDataProvider {
  async getRuleSetOptions(): Promise<Array<RuleSetOption>> {
    try {
      const request = {
        companyId: this.dependencies.getActiveCompany().companyId,
      };

      const response = await this.dependencies.api.clients.IntegrityMonitorRuleSets.getRuleSetIdentifiers(
        request
      ).toPromise();

      if (!response) {
        console.error('An error occurred while fetching rule sets.');
        return [];
      }

      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async assignRulesToRuleSets(
    companyId: string,
    ruleIds: Array<string>,
    ruleSetIds: Array<string>
  ): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRuleSets.assignRulesToRuleSets(
        companyId,
        ruleIds,
        ruleSetIds
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
